import { DialogBlock, DialogTriggerContext, Dialog as DigdirDialog, DialogTrigger as DigdirDialogTrigger, } from "@digdir/designsystemet-react";
import cn from "clsx";
import * as React from "react";
/* Add our own button styles to trigger */
const DialogTrigger = React.forwardRef(({ className, ...props }, ref) => {
    return (React.createElement(DigdirDialogTrigger, { className: cn("in-button", "in-button--primary", className), ref: ref, ...props }));
});
const Dialog = DigdirDialog;
// Attach the sub-components to enable dot notation
Dialog.Block = DialogBlock;
Dialog.Trigger = DialogTrigger;
Dialog.TriggerContext = DialogTriggerContext;
// Set displayNames for better debugging and Storybook compatibility
Dialog.displayName = "Dialog";
Dialog.Block.displayName = "Dialog.Block";
Dialog.Trigger.displayName = "Dialog.Trigger";
Dialog.TriggerContext.displayName = "Dialog.TriggerContext";
export { Dialog, DialogBlock, DialogTrigger, DialogTriggerContext, };
//# sourceMappingURL=dialog.js.map